import { useEffect, useState } from 'react'
import {
    useAuth,
    useConnectionContext,
    useExecutionReportContext,
    useReportsContext,
    useUser
} from '../../context'
import { Button, Drawer, LinearProgress, Typography, Box } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faClock,
    faComment,
    faEye,
    faPaperPlane,
    faWrench,
    faFilePdf,
    faCloudUploadAlt,
    faPlay,
    faFileExport
} from '@fortawesome/free-solid-svg-icons'
import { useNavigate, useParams } from 'react-router-dom'
import { Close } from '@mui/icons-material'
import { useAlertContext } from '../../context/Alert.context'
import { useStatus } from '../../context/Status.context'
import { GenerationStatusModal } from '../../dialogs/StatusModal'

export const MenuActividades = ({
    openMenu,
    setOpenMenu,
    id,
    setOpen3D /* , report */
}) => {
    const { setConfirm } = useAlertContext()
    const {
        admin,
        isSapExecutive,
        isOperator,
        isShiftManager,
        isSuperAdmin,
        isOperatorInspector,
        isUniversalInspector,
        isUniversalChief
    } = useUser()
    const { userData } = useAuth()
    const { isOnline } = useConnectionContext()
    const {
        report,
        terminarJornada,
        enviarOt,
        cerrarOt: cerrarOtContext,
        elevarReporte,
        getReports,
        updateLocalReport
    } = useReportsContext()
    const { initiatePdfGeneration, status, setstatus } = useStatus()
    const {
        executionReport,
        setExecutionReport,
        serieEquipo,
        machineData,
        habilite3D,
        puedeEnviar,
        puedeCerrar,
        puedeRechazar,
        puedeTerminarJornada,
        totalBacklogs,
        forwardReport,
        rejectReport,
        vistaPrevia,
        openMessages,
        openBacklogsResume,
        setIsTermJornada,
        setOpenReportCommitModal,
        reportSyncStatus,
        startReport,
        exportLocalReportData
    } = useExecutionReportContext()

    const { itemsPendingSync, uploadProgress, isSyncing } = reportSyncStatus

    const { pageProgress, progress } = useReportsContext()
    const navigate = useNavigate()

    const currentUserId = userData?._id
    const userHasStarted = report?.ejecuciones?.some(
        (e) =>
            (e.userId?._id || e.userId)?.toString() === currentUserId?.toString() &&
			e.termino === null
    )

    const handleIniciarOt = async () => {
        if (!report || !report._id) return
        try {
            setstatus({
                status: 'generating',
                message: 'Iniciando Orden de Trabajo...'
            })

            const executionData = await startReport(report._id, report)
            if (executionData) {
                setExecutionReport(executionData)
            } else {
                // Modo Offline: startReport retorna null porque encola la acción.
                // Actualizamos manualmente el 'report' local aquí para que la UI se refresque de inmediato
                const now = new Date()
                const currentEjecuciones = report.ejecuciones || []
                const updatedEjecuciones = [
                    ...currentEjecuciones,
                    {
                        userId: userData,
                        inicio: now,
                        termino: null
                    }
                ]
                // Actualizamos el contexto de reportes, lo que forzará un re-render del menú y la pauta
                updateLocalReport(report._id, {
                    dateInit: report.dateInit || now,
                    state: 'En proceso',
                    ejecuciones: updatedEjecuciones
                })
            }

            setstatus({
                status: 'completed',
                message: 'Orden de Trabajo iniciada correctamente.'
            })
            setOpenMenu(false)
        } catch (error) {
            console.error('Error al iniciar OT:', error)
            setstatus({
                status: 'error',
                message: 'No se pudo iniciar la OT.',
                errorDetails: { info: error.message }
            })
        }
    }

    const handleSyncWarning = (action) => {
        if (isSyncing) {
            const msg = `Hay ${itemsPendingSync} actividades sincronizándose (${uploadProgress}%). \n\nPor favor espere a que termine el proceso antes de ${action} para asegurar que no se pierdan datos.`
            alert(msg)
            return false
        }
        return true
    }

    const mensajeTerminoJornada = () => {
        if (!isOnline) {
            alert(
                'Debe estar conectado a internet para terminar la jornada y sincronizar las horas efectivas.'
            )
            return
        }
        if (!handleSyncWarning('terminar jornada')) return
        setIsTermJornada(true)
        setOpenReportCommitModal(true)
        setOpenMenu(false)
    }

    const handleGeneratePdf = async () => {
        if (!report || !report._id) {
            alert('No hay reporte disponible para generar el PDF.')
            return
        }

        try {
            await initiatePdfGeneration(report)
        } catch (error) {
            console.error(
                'Error initiating PDF generation from MenuActividades:',
                error
            )
            setstatus({
                status: 'error',
                message: 'Ocurrió un error al iniciar la generación del PDF.',
                errorDetails: {
                    code: error.code || 'N/A',
                    info: error.message || 'Error desconocido'
                }
            })
        }
    }

    useEffect(() => {
        console.log('report', report)
    }, [report])

    return (
        <Drawer
            open={openMenu}
            onClose={() => {
                setOpenMenu(false)
            }}
            anchor="right"
        >
            <div style={{ width: 250, height: '100%' }}>
                <div
                    style={{
                        padding: 10,
                        backgroundColor: '#F9F9F9',
                        height: '100%',
                        overflowY: 'auto'
                    }}
                >
                    <div style={{ textAlign: 'center', width: '100%' }}>
                        <h2 style={{ margin: 0 }}>OT {id}</h2>
                        <p style={{ margin: 0 }}>
                            {report && report.reportType === 'Mantención' ? 'OM' : 'Aviso'}{' '}
							SAP: <strong>{report && report.sapId ? report.sapId : ''}</strong>
                        </p>
                        <p style={{ margin: 0 }}>
							Serie Equipo:{' '}
                            <strong>
                                {report &&
									report.maquina &&
									report.maquina.equid &&
									report.maquina.equid.replace('00000000', '')}
                            </strong>
                        </p>
                        <p style={{ margin: 0 }}>
							Tipo de pauta: <strong>{report && report.guide}</strong>
                        </p>
                        <p style={{ margin: 0 }}>
							Flota:{' '}
                            <strong>
                                {report &&
									report.maquina &&
									`${report.maquina.type} ${report.maquina.model}`}{' '}
                            </strong>
                        </p>
                        <p style={{ margin: 0 }}>
							Total hallazgos: <strong>{totalBacklogs}</strong>
                        </p>
                        {report && report.testMode && (
                            <p
                                style={{
                                    backgroundColor: 'red',
                                    color: 'white',
                                    marginBottom: 0
                                }}
                            >
                                <strong>Modo Test</strong>
                            </p>
                        )}
                        {machineData && (
                            <p style={{ margin: 0 }}>
								Modelo Máquina {machineData.model}, N°{machineData.equ}
                            </p>
                        )}
                        {habilite3D && (
                            <Button
                                variant="contained"
                                disabled={!habilite3D}
                                style={{
                                    paddingLeft: 20,
                                    paddingRight: 20,
                                    paddingTop: 10,
                                    paddingBottom: 10
                                }}
                                onClick={() => {
                                    setOpen3D(true)
                                }}
                            >
                                <strong>3D</strong>
                            </Button>
                        )}
                    </div>
                    <div style={{ margin: '20px 0px 10px 0px' }}>
                        <p
                            style={{ textAlign: 'center', fontSize: 16, margin: '10px 0px' }}
                        >
							Avance en esta hoja: {pageProgress}%
                        </p>
                        <LinearProgress
                            variant="determinate"
                            value={pageProgress}
                            style={{ width: '100%' }}
                        />
                        <p
                            style={{ textAlign: 'center', fontSize: 16, margin: '10px 0px' }}
                        >
							Avance total: {progress}%
                        </p>
                        <LinearProgress
                            variant="determinate"
                            value={progress}
                            style={{ width: '100%' }}
                        />
                    </div>

                    {isSyncing && (
                        <Box
                            sx={{
                                mb: 2,
                                p: 1.5,
                                bgcolor: '#e3f2fd',
                                borderRadius: 1,
                                border: '1px solid #90caf9'
                            }}
                        >
                            <Typography
                                variant="caption"
                                display="block"
                                sx={{ fontWeight: 'bold', color: '#1976d2', mb: 0.5 }}
                            >
                                <FontAwesomeIcon
                                    icon={faCloudUploadAlt}
                                    style={{ marginRight: 5 }}
                                />
								Sincronizando
                            </Typography>
                            <LinearProgress
                                variant="determinate"
                                value={uploadProgress}
                                sx={{ height: 6, borderRadius: 3 }}
                            />
                            <Typography
                                variant="caption"
                                display="block"
                                sx={{ textAlign: 'right', mt: 0.5, color: '#1976d2' }}
                            >
                                {itemsPendingSync} pendientes ({uploadProgress}%)
                            </Typography>
                        </Box>
                    )}

                    {isUniversalInspector && !userHasStarted && (
                        <Button
                            variant="contained"
                            color="warning"
                            style={{ padding: 10, width: '100%', marginBottom: 20 }}
                            onClick={handleIniciarOt}
                            disabled={isSyncing || (report && report.level > 0)}
                        >
                            <FontAwesomeIcon icon={faPlay} style={{ marginRight: 10 }} />{' '}
								INICIAR OT
                        </Button>
                    )}

                    <br />
                    {(puedeEnviar ||
						((admin || isSuperAdmin || isOperatorInspector) &&
							report &&
							report.level < 2)) && (
                        <Button
                            variant="contained"
                            color="primary"
                            disabled={
                                (progress < 100 && !(report && report.testMode)) || isSyncing
                            }
                            style={{ padding: 10, width: '100%', marginBottom: 20 }}
                            onClick={() =>
                                handleSyncWarning('enviar la OT') && forwardReport()
                            }
                        >
                            <FontAwesomeIcon
                                icon={faPaperPlane}
                                style={{ marginRight: 10 }}
                            />{' '}
							Enviar OT
                        </Button>
                    )}
                    {(puedeRechazar ||
						((admin || isSuperAdmin || isOperatorInspector) &&
							report &&
							report.level > 0 &&
							report.level < 4)) && (
                        <Button
                            variant="contained"
                            color="error"
                            style={{ padding: 10, width: '100%', marginBottom: 20 }}
                            onClick={rejectReport}
                        >
                            <Close style={{ marginRight: 10 }} />
							Rechazar OT
                        </Button>
                    )}
                    {(puedeCerrar ||
						((admin || isSuperAdmin || isOperatorInspector) &&
							report &&
							(report.level === 3 ||
								(report.level === 2 &&
									report.reportType !== 'Mantención')))) && (
                        <Button
                            variant="contained"
                            color="success"
                            style={{ padding: 10, width: '100%', marginBottom: 20 }}
                            disabled={
                                (progress < 100 && !(report && report.testMode)) || isSyncing
                            }
                            onClick={() => handleSyncWarning('Cerrar OT') && forwardReport()}
                        >
                            <FontAwesomeIcon
                                icon={faPaperPlane}
                                style={{ marginRight: 10 }}
                            />{' '}
							Cerrar OT
                        </Button>
                    )}
                    {report &&
						report.level === 4 &&
						progress === 100 &&
						executionReport && (
                        <Button
                            variant="contained"
                            color="primary"
                            style={{ padding: 10, width: '100%', marginBottom: 20 }}
                            onClick={handleGeneratePdf}
                            disabled={status.status === 'generating'}
                        >
                            <FontAwesomeIcon icon={faFilePdf} style={{ marginRight: 10 }} />{' '}
								Generar PDF
                        </Button>
                    )}
                    {puedeTerminarJornada && (
                        <Button
                            onClick={mensajeTerminoJornada}
                            variant="contained"
                            color="primary"
                            style={{ padding: 10, width: '100%', marginBottom: 20 }}
                            disabled={isSyncing}
                        >
                            <FontAwesomeIcon icon={faClock} style={{ marginRight: 10 }} />{' '}
							Terminar Jornada
                        </Button>
                    )}
                    <Button
                        variant="contained"
                        color="primary"
                        style={{ padding: 10, width: '100%', marginBottom: 20 }}
                        onClick={openBacklogsResume}
                    >
                        <FontAwesomeIcon icon={faWrench} style={{ marginRight: 10 }} />{' '}
						Resumen Hallazgos
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        style={{ padding: 10, width: '100%', marginBottom: 20 }}
                        onClick={openMessages}
                    >
                        <FontAwesomeIcon icon={faComment} style={{ marginRight: 10 }} />{' '}
						Mensajes de flujo
                    </Button>
                    {(puedeCerrar ||
						admin ||
						isOperator ||
						isShiftManager ||
						isSuperAdmin) && (
                        <Button
                            variant="contained"
                            color="primary"
                            style={{ padding: 10, width: '100%', marginBottom: 20 }}
                            onClick={vistaPrevia}
                        >
                            <FontAwesomeIcon icon={faEye} style={{ marginRight: 10 }} />{' '}
							Resumen Insumos/Materiales
                        </Button>
                    )}
                    <Button
                        variant="contained"
                        color="warning"
                        style={{ padding: 10, width: '100%', marginBottom: 20, fontWeight: 'bold' }}
                        onClick={async () => {
                            if (exportLocalReportData) {
                                await exportLocalReportData(report?._id)
                            }
                        }}
                    >
                        <FontAwesomeIcon icon={faFileExport} style={{ marginRight: 10 }} />{' '}
                        Exportar Pauta (JSON)
                    </Button>
                </div>
                <GenerationStatusModal />
            </div>
        </Drawer>
    )
}
